/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Final_Cta_SubtitleInputs */

const en_landing_final_cta_subtitle = /** @type {(inputs: Landing_Final_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your data. Your privacy. Your career.`)
};

const de_landing_final_cta_subtitle = /** @type {(inputs: Landing_Final_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Daten. Deine Privatsphäre. Deine Karriere.`)
};

const fr_landing_final_cta_subtitle = /** @type {(inputs: Landing_Final_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes données. Ta vie privée. Ta carrière.`)
};

const es_landing_final_cta_subtitle = /** @type {(inputs: Landing_Final_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus datos. Tu privacidad. Tu carrera.`)
};

const it_landing_final_cta_subtitle = /** @type {(inputs: Landing_Final_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi dati. La tua privacy. La tua carriera.`)
};

const nl_landing_final_cta_subtitle = /** @type {(inputs: Landing_Final_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw data. Jouw privacy. Jouw carrière.`)
};

const pl_landing_final_cta_subtitle = /** @type {(inputs: Landing_Final_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje dane. Twoja prywatność. Twoja kariera.`)
};

const fi_landing_final_cta_subtitle = /** @type {(inputs: Landing_Final_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinun datasi. Sinun yksityisyytesi. Sinun urasi.`)
};

const da_landing_final_cta_subtitle = /** @type {(inputs: Landing_Final_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dine data. Dit privatliv. Din karriere.`)
};

const sv_landing_final_cta_subtitle = /** @type {(inputs: Landing_Final_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din data. Din integritet. Din karriär.`)
};

/**
* | output |
* | --- |
* | "Your data. Your privacy. Your career." |
*
* @param {Landing_Final_Cta_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_final_cta_subtitle = /** @type {((inputs?: Landing_Final_Cta_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Final_Cta_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_final_cta_subtitle(inputs)
	if (locale === "fr") return fr_landing_final_cta_subtitle(inputs)
	if (locale === "es") return es_landing_final_cta_subtitle(inputs)
	if (locale === "it") return it_landing_final_cta_subtitle(inputs)
	if (locale === "nl") return nl_landing_final_cta_subtitle(inputs)
	if (locale === "pl") return pl_landing_final_cta_subtitle(inputs)
	if (locale === "fi") return fi_landing_final_cta_subtitle(inputs)
	if (locale === "da") return da_landing_final_cta_subtitle(inputs)
	if (locale === "sv") return sv_landing_final_cta_subtitle(inputs)
	return en_landing_final_cta_subtitle(inputs)
});